import React from 'react';
import { 
  LayoutDashboard, 
  Building2, 
  CheckSquare, 
  GitBranch, 
  FileSpreadsheet, 
  Settings, 
  LogOut, 
  ChevronLeft, 
  ChevronRight, 
  BarChart3, 
  Key, 
  Mail, 
  FileText, 
  Megaphone, 
  Bot,
  Zap
} from 'lucide-react';

const Sidebar = ({ activeTab, setActiveTab, user, onLogout, collapsed, setCollapsed }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Panel de Control', icon: LayoutDashboard },
    { id: 'empresas', label: 'Empresas', icon: Building2 },
    { id: 'tareas', label: 'Tareas', icon: CheckSquare },
    { id: 'embudos', label: 'Embudos de Venta', icon: GitBranch },
    { id: 'evaluaciones', label: 'Evaluaciones Comerciales', icon: FileSpreadsheet },
    { id: 'formularios', label: 'Formularios Públicos', icon: FileText },
    { id: 'marketing', label: 'Marketing y Social', icon: Megaphone },
    { id: 'google-tools', label: 'Herramientas de Google', icon: Settings },
    { id: 'gmail', label: 'Gmail Panel', icon: Mail },
    { id: 'agents', label: 'Agentes de IA', icon: Bot },
    { id: 'automations', label: 'Automatizaciones', icon: Zap },
    { id: 'reportes', label: 'Reportes', icon: BarChart3 },
    { id: 'admin', label: 'Administración', icon: Key }
  ];

  return (
    <div className={`bg-[#0f172a] text-white min-h-screen transition-all duration-300 flex flex-col justify-between ${collapsed ? 'w-16' : 'w-64'}`}>
      <div>
        {/* Encabezado del Sidebar */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-slate-800">
          {!collapsed && <span className="font-bold text-lg tracking-wider text-[#cca353]">INFINITO CRM</span>}
          <button 
            onClick={() => setCollapsed(!collapsed)} 
            className="p-1.5 rounded-lg bg-slate-800 hover:bg-slate-700 transition-colors ml-auto"
          >
            {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
          </button>
        </div>

        {/* Links de Navegación */}
        <nav className="mt-4 px-2 space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
                  isActive 
                    ? 'bg-[#cca353] text-white shadow-lg shadow-[#cca353]/20 font-semibold' 
                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                }`}
              >
                <Icon size={20} className={isActive ? 'text-white' : 'text-slate-400'} />
                {!collapsed && <span className="truncate">{item.label}</span>}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Botón de Salida */}
      <div className="p-2 border-t border-slate-800">
        <button
          onClick={onLogout}
          className="w-full flex items-center space-x-3 px-3 py-2.5 rounded-xl text-sm font-medium text-red-400 hover:bg-red-500/10 transition-all duration-200"
        >
          <LogOut size={20} />
          {!collapsed && <span>Cerrar Sesión</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;